import {Injectable} from '@angular/core';
import {AuthService, RestClientService} from 'shared-lib';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private restClient: RestClientService, private authService: AuthService) {
  }

  public withdraw(): Observable<void> {
    return this.restClient.post<void>(`/users/${this.authService.getCurrentUser()!.id}/withdraw`, null);
  }
}
